<template>
	<div id="jointsurvey-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4">JOINT SURVEY</h4>
							<a id="add_jointsurvey_btn" class="btn btn-success btn-sm" href="#" role="button" data-bs-toggle="modal" data-bs-target="#addJointSurveyModal" v-if="['110', '111'].indexOf(all_permissions) >= 0">ADD</a>
						</div>
					</div>
				</div>
				<DataTableComponent :dataprops="dataprops" @view-object="viewJointSurvey" @upload-object="uploadImages" @duplicate-object="duplicateObject" @edit-object="prepareEditJointSurvey" @toggle-object-status="toggleJointSurvey" @print-object="printObject"></DataTableComponent>
			</div>
		</div>
		<div class="modal fade" ref="addEditModal" id="addJointSurveyModal" tabindex="-1" aria-labelledby="addJointSurveyModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addJointSurveyModalLabel">Add/Edit JointSurvey</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-4 gy-3 gy-md-0">
							<div class="col-md-2">
								<label for="add_jointsurvey_ref_no" class="form-label text-uppercase fw-bold me-3">Ref No</label>
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.ref_no" id="add_jointsurvey_ref_no" placeholder="ref"/>
								</div>
							</div>
							<div class="col-md-8">
								<label for="add_jointsurvey_company_id" class="form-label text-uppercase fw-bold me-3">Company <span class="mandatory">*</span></label>
								<div>
									<select class="form-select" v-model="jointsurveyForAdd.company_id" id="add_company_id">
										<optgroup v-if="allCompanyIdList" label="Choose Company">
											<template v-for="companyId in allCompanyIdList" :key="companyId.id">
												<option :value="companyId.id">{{ companyId.name }}</option>
											</template>
										</optgroup>
									</select>
								</div>
								<div v-if="v$.jointsurveyForAdd.company_id.$error" class="mandatory ms-3">Mandatory</div>
							</div>
							<div class="col-md-2">
								<label for="add_jointsurvey_date_of_issue" class="form-label text-uppercase fw-bold me-3">Date Of Issue</label>
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.date_of_issue" id="add_jointsurvey_date_of_issue" placeholder="Enter Date Of Issue" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-12">
								<label for="add_jointsurvey_customer_name" class="form-label text-uppercase fw-bold me-3">To Customer</label>
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.customer_name" id="add_jointsurvey_customer_name" placeholder="Enter Customer Name" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-12">
								<label for="add_jointsurvey_company_name" class="form-label text-uppercase fw-bold me-3">Seamarine Company</label>
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.company_name" id="add_jointsurvey_company_name" placeholder="Enter Company Name" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-12">
								<label for="add_jointsurvey_address" class="form-label text-uppercase fw-bold me-3">Address</label>
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.address" id="add_jointsurvey_address" placeholder="Enter the address" />
								</div>
							</div>
						</div>
						<div class="row pb-2 border-bottom mb-2">
							<div class="col-1 text-center">1.</div>
							<div class="col-11">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.instruction_1" id="add_jointsurvey_instruction_1" placeholder="Enter Instruction 1" />
								</div>
							</div>
						</div>
						<div class="row pb-2 border-bottom mb-2">
							<div class="col-1 text-center">2.</div>
							<div class="col-11">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.instruction_2" id="add_jointsurvey_instruction_2" placeholder="Enter Instruction 2" />
								</div>
							</div>
						</div>
						<div class="row pb-2 border-bottom mb-2">
							<div class="col-1 text-center">3.</div>
							<div class="col-11">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.instruction_3" id="add_jointsurvey_instruction_3" placeholder="Enter Instruction 3" />
								</div>
							</div>
						</div>
						<div class="row pb-2 border-bottom mb-2">
							<div class="col-1 text-center">4.</div>
							<div class="col-11">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.instruction_4" id="add_jointsurvey_instruction_4" placeholder="Enter Instruction 4" />
								</div>
							</div>
						</div>
						<div class="row pb-2 border-bottom mb-2">
							<div class="col-1 text-center">5.</div>
							<div class="col-11">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.instruction_5" id="add_jointsurvey_instruction_5" placeholder="Enter Instruction 5" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_tank_no" class="form-label text-uppercase fw-bold mb-0">Tank No <span class="mandatory">*</span></label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.tank_no" id="add_jointsurvey_tank_no" placeholder="Enter Tank No" />
								</div>
								<div v-if="v$.jointsurveyForAdd.tank_no.$error" class="mandatory ms-3">Mandatory</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_mfg_date" class="form-label text-uppercase fw-bold mb-0">Mfg Date</label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.mfg_date" id="add_jointsurvey_mfg_date" placeholder="Enter Mfg Date" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_mgw" class="form-label text-uppercase fw-bold mb-0">Mgw</label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.mgw" id="add_jointsurvey_mgw" placeholder="Enter Mgw" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_csc" class="form-label text-uppercase fw-bold mb-0">Csc</label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.csc" id="add_jointsurvey_csc" placeholder="Enter Csc" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_tare_weight" class="form-label text-uppercase fw-bold mb-0">Tare Weight</label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.tare_weight" id="add_jointsurvey_tare_weight" placeholder="Enter Tare Weight" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 d-flex justify-content-end align-items-center">
								<label for="add_jointsurvey_capacity" class="form-label text-uppercase fw-bold mb-0">Capacity</label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<input type="text" class="form-control" v-model="jointsurveyForAdd.capacity" id="add_jointsurvey_capacity" placeholder="Enter Capacity" />
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 text-end">
								<label for="add_jointsurvey_comments" class="form-label text-uppercase fw-bold mb-0">Comments</label>
							</div>
							<div class="col-md-9 col-6">
								<div>
									<textarea class="form-control" v-model="jointsurveyForAdd.comments" id="add_jointsurvey_comments" placeholder="Enter Comments" rows="3"></textarea>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-md-3 col-6 text-end">
								<label for="add_jointsurvey_surveyor_id" class="form-label text-uppercase fw-bold me-3">Surveyor <span class="mandatory">*</span></label>
							</div>
							<div class="col-md-4 col-6">
								<div>
									<multiselect v-model="jointsurveyForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
								</div>
								<div v-if="v$.jointsurveyForAdd.surveyor_id.$error" class="mandatory ms-3">Mandatory</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal" @click="cancelAddEdit()">CLOSE</button>
						<button type="button" class="btn btn-dark btn-sm" @click="saveJointSurvey()">SAVE CHANGES</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" ref="readModal" id="readJointSurveyModal" tabindex="-1" aria-labelledby="readJointSurveyModalLabel" aria-hidden="true" v-if="readJointSurvey">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="readJointSurveyModalLabel">View JointSurvey</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Ref No</label>
								<div>
									<span v-if="readJointSurvey.ref_no">{{ readJointSurvey.ref_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Company</label>
								<div>
									<span v-if="readJointSurvey.company?.title">{{ readJointSurvey.company?.title }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Date Of Issue</label>
								<div>
									<span v-if="readJointSurvey.date_of_issue">{{ readJointSurvey.date_of_issue }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Address</label>
								<div>
									<span v-if="readJointSurvey.address">{{ readJointSurvey.address }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Customer Name</label>
								<div>
									<span v-if="readJointSurvey.customer_name">{{ readJointSurvey.customer_name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Company Name</label>
								<div>
									<span v-if="readJointSurvey.company_name">{{ readJointSurvey.company_name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-6">
								<label class="form-label text-uppercase fw-bold m-0">Instruction 1</label>
								<div>
									<span v-if="readJointSurvey.instruction_1">{{ readJointSurvey.instruction_1 }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6">
								<label class="form-label text-uppercase fw-bold m-0">Instruction 2</label>
								<div>
									<span v-if="readJointSurvey.instruction_2">{{ readJointSurvey.instruction_2 }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6">
								<label class="form-label text-uppercase fw-bold m-0">Instruction 3</label>
								<div>
									<span v-if="readJointSurvey.instruction_3">{{ readJointSurvey.instruction_3 }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6">
								<label class="form-label text-uppercase fw-bold m-0">Instruction 4</label>
								<div>
									<span v-if="readJointSurvey.instruction_4">{{ readJointSurvey.instruction_4 }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-12">
								<label class="form-label text-uppercase fw-bold m-0">Instruction 5</label>
								<div>
									<span v-if="readJointSurvey.instruction_5">{{ readJointSurvey.instruction_5 }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Tank No</label>
								<div>
									<span v-if="readJointSurvey.tank_no">{{ readJointSurvey.tank_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Mfg Date</label>
								<div>
									<span v-if="readJointSurvey.mfg_date">{{ formatMySQLDate(readJointSurvey.mfg_date, "MMM dd, yyyy") }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Mgw</label>
								<div>
									<span v-if="readJointSurvey.mgw">{{ readJointSurvey.mgw }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Tare Weight</label>
								<div>
									<span v-if="readJointSurvey.tare_weight">{{ readJointSurvey.tare_weight }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Capacity</label>
								<div>
									<span v-if="readJointSurvey.capacity">{{ readJointSurvey.capacity }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Csc</label>
								<div>
									<span v-if="readJointSurvey.csc">{{ readJointSurvey.csc }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Comments</label>
								<div>
									<span v-if="readJointSurvey.comments">{{ readJointSurvey.comments }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4 gy-4 gy-md-0">
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Surveyor</label>
								<div>
									<span v-if="readJointSurvey.surveyor?.name">{{ readJointSurvey.surveyor?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Status</label>
								<div>
									<span class="badge rounded-pill bg-success" v-if="readJointSurvey.status == 1">ACTIVE</span>
									<span class="badge rounded-pill bg-danger" v-if="readJointSurvey.status == 0">INACTIVE</span>
								</div>
							</div>
							<div class="col-md-4">
								<label class="form-label text-uppercase fw-bold m-0">Created By</label>
								<div>
									<span v-if="readJointSurvey.creator?.title">{{ readJointSurvey.creator?.title }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal">CLOSE</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Upload Images -->
		<UploadImages :dataprops="uploadDataprops" @refresh-object="refreshObject"></UploadImages>
		<!-- Upload Images -->
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			ref_no: "",
			address: "",
			company_id: null,
			date_of_issue: "",
			customer_name: "",
			company_name: "",
			instruction_1: "",
			instruction_2: "",
			instruction_3: "",
			instruction_4: "",
			instruction_5: "",
			tank_no: "",
			mfg_date: "",
			mgw: "",
			tare_weight: "",
			capacity: "",
			csc: "",
			comments: "",
			surveyor_id: null,

			action: ""
		};
	}
	function initialStateValidations() {
		return {
			company_id: {required},
			tank_no: {required},
			surveyor_id: {required}
		};
	}
	export default {
		name: "JointSurveymaster",
		props: ["current_user_id", "all_permissions"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				dataprops: {
					id: "jointsurvey-list",
					class: "a",
					base_url: "/api/jointsurvey/",
					columns: [
						{title: "Ref No", property: "ref_no"},
						{title: "Company", property: "company.name", alt_value: "Not Specified"},
						{title: "Date Of Issue", property: "date_of_issue"},
						{title: "Customer Name", property: "customer_name"},
						{title: "Tank No", property: "tank_no"},
						{title: "Surveyor", property: "surveyor.name", alt_value: "Not Specified"},
						{title: "Created By", property: "creator.name", alt_value: "Not Specified"}
					],
					data_to_send: {current_user_id: this.current_user_id},
					reload: false,
					search: "simple"
				},
				uploadDataprops: {
					relatedObject: null,
					name: "JointSurvey",
				},
				addEditModal: null,
				readModal: null,
				currentUser: siteUserObject,
				jointsurveyForAdd: initialState(),
				readJointSurvey: {},
				allCompanyIdList: [],
				allSurveyorIdList: []
			};
		},
		validations() {
			return {
				jointsurveyForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.jointsurveyForAdd = initialState();
				this.v$.$reset();
			},
			duplicateObject(jointsurvey) {
				let that = this;
				this.showConfirm("Are you sure you want to create a duplicate of this record?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						if (jointsurvey.surveyor_id) {
							if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
								let _allRelationList = this.allSurveyorIdList;
								let relationId = parseInt(jointsurvey.surveyor_id);
								jointsurvey.surveyor_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						this.jointsurveyForAdd = Object.assign({}, jointsurvey);
						this.jointsurveyForAdd.id = 0;
						this.jointsurveyForAdd.ref_no = null;
						this.tankNoVerified = false;
						this.addEditModal.show();
					}
				});
			},
			async saveJointSurvey(event) {
				var thisVar = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				if (!this.jointsurveyForAdd.action || this.jointsurveyForAdd.action == "") this.jointsurveyForAdd.action = "details";
				if ( this.jointsurveyForAdd.surveyor_id != 'null' && typeof this.jointsurveyForAdd.surveyor_id === 'object' && this.jointsurveyForAdd.surveyor_id.id) {
					this.jointsurveyForAdd.surveyor_id = this.jointsurveyForAdd.surveyor_id.id;
				}
				this.jointsurveyForAdd.created_by = this.current_user_id;
				// $("#addJointSurveyModal").modal("hide");
				bootstrap.Modal.getInstance(document.getElementById('addJointSurveyModal')).hide();
				this.showLoading("Saving ...");
				axios
					.post("/jointsurvey/save", {jointsurvey: this.jointsurveyForAdd})
					.then(async function (response) {
						thisVar.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Ajax to submit
							thisVar.showToast("Joint Survey saved successfully", "success", "bottom", 3000);
							setTimeout(() => {
								thisVar.dataprops.reload = true;
							}, 1500);
							thisVar.jointsurveyForAdd = initialState();
							thisVar.v$.$reset();
							thisVar.allCompanyIdList = await thisVar.loadAllCompany(true);
							thisVar.allSurveyorIdList = await thisVar.loadAllSurveyor(true);
						} else thisVar.showErrors("Joint Survey could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						thisVar.closeSwal();
						thisVar.showToast("Joint Survey could not be saved successfully", "error", "bottom", 3000);
					});
			},
			prepareEditJointSurvey(jointsurvey) {
				this.jointsurveyForAdd = Object.assign({}, jointsurvey);
				this.addEditModal.show();
				if (this.jointsurveyForAdd.surveyor_id) {
					if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
						let _allRelationList = this.allSurveyorIdList;
						let relationId = parseInt(this.jointsurveyForAdd.surveyor_id);
						this.jointsurveyForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
					}
				}
			},
			viewJointSurvey(jointsurvey) {
				this.readJointSurvey = jointsurvey;
				this.readModal.show();
			},
			toggleJointSurvey(jointsurvey, status) {
				var thisVar = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "reactivate" : "deactivate") + ' the Joint Survey - <br/>"' + jointsurvey.ref_no + '"?',
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						thisVar.jointsurveyForAdd = jointsurvey;
						thisVar.jointsurveyForAdd.status = status;
						thisVar.jointsurveyForAdd.action = "status";
						thisVar.saveJointSurvey();
					}
				});
			},
			printObject(jointsurvey) {
				window.location = this.docRoot+'/jointsurvey/export-to-pdf/' + jointsurvey.id;
				this.showToast("Printing. Please wait ...", "success", "bottom", 3000);
			},
			async uploadImages(jointsurvey) {
				this.showLoading("Loading images ...");
				await this.refreshObject(jointsurvey, "JointSurvey", 1);
				this.closeSwal();
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			this.addEditModal = new bootstrap.Modal(this.$refs.addEditModal, {backdrop: "static", keyboard: false});
			this.readModal = new bootstrap.Modal(this.$refs.readModal, {backdrop: "static", keyboard: false});
			this.allCompanyIdList = await this.loadAllCompany(true);
			let _allSurveyorIdList = await this.loadAllSurveyor(true);
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
		}
	};
</script>
